import { render, staticRenderFns } from "./config.vue?vue&type=template&id=f868c1ce"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f868c1ce')) {
      api.createRecord('f868c1ce', component.options)
    } else {
      api.reload('f868c1ce', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=f868c1ce", function () {
      api.rerender('f868c1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/logoSet/config.vue"
export default component.exports